import { render, staticRenderFns } from "./EditPricing.vue?vue&type=template&id=df24feb6&"
import script from "./EditPricing.vue?vue&type=script&lang=js&"
export * from "./EditPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports